
import { Device } from "@/types/device";
import { macApps } from "./mockApps";
import { getTenantInfo } from "@/hooks/useDevices";

export const generateMockDevices = (): Device[] => {
  const now = new Date();
  const oneHourAgo = new Date(now.getTime() - 60 * 60 * 1000);
  const oneDayAgo = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const threeDaysAgo = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000);
  const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
  const twoWeeksAgo = new Date(now.getTime() - 14 * 24 * 60 * 60 * 1000);
  
  console.log("Generating mock Apple devices - should return 20 devices");
  
  // Generate MacBooks (6 devices)
  const macbooks = [
    {
      id: "mac-mbp-m3-pro-01",
      name: "MacBook Pro 16\" - Executive",
      os_type: "macOS",
      os_version: "14.4 (Sonoma)",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "MBP-M3-PRO-CEO",
      battery_level: 92,
      battery_status: "charging",
      serial_number: "C02G40ZNMD6N",
      ip_address: "192.168.1.101",
      installed_apps: macApps,
      department: "Executive",
      location: "Headquarters"
    },
    {
      id: "mac-mbp-m3-max-02",
      name: "MacBook Pro 16\" - Creative Director",
      os_type: "macOS",
      os_version: "14.4 (Sonoma)",
      status: "active",
      last_seen: oneHourAgo.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "MBP-M3-MAX-CD",
      battery_level: 78,
      battery_status: "discharging",
      serial_number: "C02F40ZNMD6M",
      ip_address: "192.168.1.102",
      installed_apps: macApps,
      department: "Design",
      location: "Headquarters"
    },
    {
      id: "mac-mba-m3-03",
      name: "MacBook Air 15\" - Marketing Manager",
      os_type: "macOS",
      os_version: "14.3 (Sonoma)",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "MBA-M3-MKT",
      battery_level: 65,
      battery_status: "discharging",
      serial_number: "C02H30ABCD9E",
      ip_address: "192.168.1.103",
      installed_apps: macApps.slice(0, 8),
      department: "Marketing",
      location: "Headquarters"
    },
    {
      id: "mac-mbp-m2-pro-05",
      name: "MacBook Pro 14\" - Developer Lead",
      os_type: "macOS",
      os_version: "14.4 (Sonoma)",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "MBP-M2-DEV1",
      battery_level: 88,
      battery_status: "charging",
      serial_number: "C02F39ABCF7D",
      ip_address: "192.168.1.105",
      installed_apps: macApps,
      department: "Engineering",
      location: "Headquarters"
    },
    {
      id: "mac-mbp-m1-pro-07",
      name: "MacBook Pro 14\" - Product Manager",
      os_type: "macOS",
      os_version: "13.6.1 (Ventura)",
      status: "active",
      last_seen: threeDaysAgo.toISOString(),
      created_at: twoWeeksAgo.toISOString(),
      hostname: "MBP-M1-PM1",
      battery_level: 62,
      battery_status: "charging",
      serial_number: "C02D33ABCF5B",
      ip_address: "192.168.1.107",
      installed_apps: macApps.slice(0, 7),
      department: "Product",
      location: "Singapore Office"
    },
    {
      id: "mac-mbp-intel-10",
      name: "MacBook Pro 16\" - Support Staff",
      os_type: "macOS",
      os_version: "11.7.10 (Big Sur)",
      status: "pending",
      last_seen: now.toISOString(),
      created_at: now.toISOString(),
      hostname: "MBP-INTEL-SUP1",
      battery_level: 100,
      battery_status: "charging",
      serial_number: "C02A24ABCF28",
      ip_address: "192.168.1.110",
      installed_apps: [],
      department: "Support",
      location: "London Office"
    },
  ];
  
  // Generate iPhones (5 devices)
  const iphones = [
    {
      id: "iphone-15-pro-max-01",
      name: "iPhone 15 Pro Max - CEO",
      os_type: "iOS",
      os_version: "17.4.1",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "iPhone-CEO",
      battery_level: 82,
      battery_status: "charging",
      serial_number: "GR7X40KN9DCF",
      ip_address: "192.168.1.201",
      installed_apps: [],
      department: "Executive",
      location: "Mobile"
    },
    {
      id: "iphone-15-pro-02",
      name: "iPhone 15 Pro - CMO",
      os_type: "iOS",
      os_version: "17.4.1",
      status: "active",
      last_seen: oneHourAgo.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "iPhone-CMO",
      battery_level: 67,
      battery_status: "discharging",
      serial_number: "GR7Y40KN8DCE",
      ip_address: "192.168.1.202",
      installed_apps: [],
      department: "Marketing",
      location: "Mobile"
    },
    {
      id: "iphone-14-pro-max-05",
      name: "iPhone 14 Pro Max - CTO",
      os_type: "iOS",
      os_version: "17.4.1",
      status: "active",
      last_seen: now.toISOString(),
      created_at: twoWeeksAgo.toISOString(),
      hostname: "iPhone-CTO",
      battery_level: 92,
      battery_status: "charging",
      serial_number: "FX3B40KN5DCB",
      ip_address: "192.168.1.205",
      installed_apps: [],
      department: "Engineering",
      location: "Mobile"
    },
    {
      id: "iphone-14-pro-06",
      name: "iPhone 14 Pro - Engineering Lead",
      os_type: "iOS",
      os_version: "17.4",
      status: "active",
      last_seen: oneDayAgo.toISOString(),
      created_at: twoWeeksAgo.toISOString(),
      hostname: "iPhone-Eng-Lead",
      battery_level: 38,
      battery_status: "discharging",
      serial_number: "FX3C40KN4DCA",
      ip_address: "192.168.1.206",
      installed_apps: [],
      department: "Engineering",
      location: "Mobile"
    },
    {
      id: "iphone-se-09",
      name: "iPhone SE - Support Staff",
      os_type: "iOS",
      os_version: "17.4",
      status: "active",
      last_seen: oneHourAgo.toISOString(),
      created_at: twoWeeksAgo.toISOString(),
      hostname: "iPhone-Support",
      battery_level: 51,
      battery_status: "discharging",
      serial_number: "JK7F40KN1DC7",
      ip_address: "192.168.1.209",
      installed_apps: [],
      department: "Support",
      location: "Mobile"
    }
  ];
  
  // Generate iPads (4 devices)
  const ipads = [
    {
      id: "ipad-pro-m2-01",
      name: "iPad Pro 12.9\" - Design Director",
      os_type: "iPadOS",
      os_version: "17.4.1",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "iPad-Design-Dir",
      battery_level: 88,
      battery_status: "charging",
      serial_number: "DMPW876GHCXQ",
      ip_address: "192.168.1.301",
      installed_apps: [],
      department: "Design",
      location: "Headquarters"
    },
    {
      id: "ipad-pro-m1-02",
      name: "iPad Pro 11\" - Sales Demo",
      os_type: "iPadOS",
      os_version: "17.4",
      status: "active",
      last_seen: oneHourAgo.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "iPad-Sales-Demo",
      battery_level: 45,
      battery_status: "discharging",
      serial_number: "DMPX875GHCXP",
      ip_address: "192.168.1.302",
      installed_apps: [],
      department: "Sales",
      location: "New York Office"
    },
    {
      id: "ipad-air-m1-03",
      name: "iPad Air - Marketing Coordinator",
      os_type: "iPadOS",
      os_version: "17.3.1",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "iPad-Marketing",
      battery_level: 67,
      battery_status: "discharging",
      serial_number: "DMPY874GHCXN",
      ip_address: "192.168.1.303",
      installed_apps: [],
      department: "Marketing",
      location: "Headquarters"
    },
    {
      id: "ipad-mini-05",
      name: "iPad Mini - Product Team",
      os_type: "iPadOS",
      os_version: "17.3.1",
      status: "active",
      last_seen: threeDaysAgo.toISOString(),
      created_at: twoWeeksAgo.toISOString(),
      hostname: "iPad-Product",
      battery_level: 32,
      battery_status: "discharging",
      serial_number: "DMP1872GHCXL",
      ip_address: "192.168.1.305",
      installed_apps: [],
      department: "Product",
      location: "London Office"
    }
  ];
  
  // Generate Apple Watches (2 devices)
  const appleWatches = [
    {
      id: "apple-watch-ultra-2-01",
      name: "Apple Watch Ultra 2 - CEO",
      os_type: "watchOS",
      os_version: "10.4",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "Watch-CEO",
      battery_level: 76,
      battery_status: "discharging",
      serial_number: "FVFP9876YHNJ",
      ip_address: "192.168.1.401",
      installed_apps: [],
      department: "Executive",
      location: "Wearable"
    },
    {
      id: "apple-watch-series-9-02",
      name: "Apple Watch Series 9 - CTO",
      os_type: "watchOS",
      os_version: "10.4",
      status: "active",
      last_seen: oneHourAgo.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "Watch-CTO",
      battery_level: 45,
      battery_status: "discharging",
      serial_number: "FVFQ9875YHNI",
      ip_address: "192.168.1.402",
      installed_apps: [],
      department: "Engineering",
      location: "Wearable"
    }
  ];
  
  // Generate Apple TVs (2 devices)
  const appleTVs = [
    {
      id: "apple-tv-4k-2022-01",
      name: "Apple TV 4K - Main Conference Room",
      os_type: "tvOS",
      os_version: "17.4",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "ATV-Main-Conf",
      battery_level: null,
      battery_status: null,
      serial_number: "J3KP876ZTGB4",
      ip_address: "192.168.1.501",
      installed_apps: [],
      department: "Facilities",
      location: "Main Conference Room"
    },
    {
      id: "apple-tv-4k-2021-02",
      name: "Apple TV 4K - Executive Lounge",
      os_type: "tvOS",
      os_version: "17.3",
      status: "active",
      last_seen: oneHourAgo.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "ATV-Exec-Lounge",
      battery_level: null,
      battery_status: null,
      serial_number: "J3KQ875ZTGB3",
      ip_address: "192.168.1.502",
      installed_apps: [],
      department: "Executive",
      location: "Executive Lounge"
    }
  ];
  
  // Generate Vision Pro (1 device)
  const visionPros = [
    {
      id: "vision-pro-01",
      name: "Vision Pro - R&D Lab",
      os_type: "visionOS",
      os_version: "1.1",
      status: "active",
      last_seen: now.toISOString(),
      created_at: oneWeekAgo.toISOString(),
      hostname: "Vision-RnD",
      battery_level: 85,
      battery_status: "charging",
      serial_number: "VP1P876XCN4J",
      ip_address: "192.168.1.601",
      installed_apps: [],
      department: "Research",
      location: "R&D Lab"
    }
  ];
  
  // Combine all devices
  const allAppleDevices = [
    ...macbooks,
    ...iphones,
    ...ipads,
    ...appleWatches,
    ...appleTVs,
    ...visionPros
  ];
  
  // Add tenant information to all devices
  const devicesWithTenants = allAppleDevices.map(device => {
    const tenantInfo = getTenantInfo(device.id);
    return {
      ...device,
      customer: tenantInfo.customer,
      tenantId: tenantInfo.tenantId
    };
  });
  
  console.log(`Generated ${devicesWithTenants.length} mock Apple devices with tenant information`);
  return devicesWithTenants;
};
